module.exports = __webpack_public_path__ + "static/img/about3.5e616bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about3.png
// module id = 5Kwx
// module chunks = 3